import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  setCurrentAccountByUUID,
  updateAccountTimestamp,
} from 'store/actions/account';
import { updateUser } from 'store/actions/user';
import StackSelectorDropdown from 'components/Account/StackSelectorDropdown';
import AddStackDialog from 'components/Account/AddStackDialog';
import ImageLoader from '../Shared/ImageLoader/ImageLoader';
import { getImageLink } from 'helpers/imageHelper';
import { route, imageSizes, entityNames } from 'config/constants';
import { history } from 'store/createStore';
import { createReplacePatch } from 'helpers/patchHelper';
import { isLoggedOut } from '../../helpers/accountHelper';
import theme from './theme';
import './styles.css';

class SidebarHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdownOpen: false,
      dropdownAnchorEl: null,
      isAddDialogOpen: false,
    };
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    var location = this.props.location;
    var onMouseLeave = this.props.onMouseLeave;
    if (location.pathname !== prevProps.location.pathname) {
      if (onMouseLeave) {
        onMouseLeave();
      }
    }
  }

  handleDropdownOpen = (e) => {
    if (e) {
      e.preventDefault();
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.setState({
      isDropdownOpen: true,
      dropdownAnchorEl: e.currentTarget,
    });
  };

  handleDropdownClose = () => {
    this.setState({
      isDropdownOpen: false,
      dropdownAnchorEl: null,
    });
  };

  handleAddDialogOpen = () => {
    this.setState({ isAddDialogOpen: true });
  };

  handleAddDialogClose = () => {
    this.setState({ isAddDialogOpen: false });
  };

  switchAccount = (uuid) => {
    if (uuid) {
      var setCurrentAccountByUUID = this.props.setCurrentAccountByUUID;
      var updateUser = this.props.updateUser;
      var updateAccountTimestamp = this.props.updateAccountTimestamp;
      var data = {};
      data.patches = [createReplacePatch('/lastUsedAccount', uuid)];

      setCurrentAccountByUUID(uuid);
      updateUser(data, entityNames.UPDATE_ACCOUNT_TIMESTAMP);
      updateAccountTimestamp(uuid);
      this.handleDropdownClose();
      this.handleAddDialogClose();
      history.push({
        pathname: route.ROOT,
      });
    }
  };

  render() {
    var currentAccount = this.props.currentAccount;
    var imagesLinks = this.props.imagesLinks;
    var currentUser = this.props.currentUser;
    var isCollapsed = this.props.isCollapsed;
    var isHovered = this.props.isHovered;
    var isDropdownOpen = this.state.isDropdownOpen;
    var dropdownAnchorEl = this.state.dropdownAnchorEl;
    var isAddDialogOpen = this.state.isAddDialogOpen;

    var link;
    var firstLetter;

    if (currentAccount) {
      link = getImageLink(
        currentAccount.imageUUID,
        imagesLinks,
        imageSizes.ACCOUNT_SIDEBAR
      );
      firstLetter = currentAccount.name ? currentAccount.name[0].toUpperCase() : '';
    }

    var preloaderDivider = isCollapsed && !isHovered ? 5 : 2;
    var loggedOut = isLoggedOut(currentUser);

    return (
      <div className="sidebar-header" style={theme.sidebarHeader}>
        {currentAccount && (
          <div
            className={loggedOut ? 'sidebar-header-account-static' : 'sidebar-header-account'}
            onClick={loggedOut ? undefined : this.handleDropdownOpen}
          >
            <div className="sidebar-header-logo">
              {link && (
                <ImageLoader
                  url={link}
                  spinnerWidth={imageSizes.ACCOUNT_SIDEBAR.width / preloaderDivider}
                />
              )}
              {!link && firstLetter}
            </div>
            <div className="sidebar-header-name">{currentAccount.name}</div>
            {!loggedOut && (
              <i
                className={
                  'material-symbols-outlined sidebar-header-chevron' +
                  (isDropdownOpen ? ' sidebar-header-chevron-open' : '')
                }
              >
                keyboard_arrow_down
              </i>
            )}
          </div>
        )}

        <StackSelectorDropdown
          open={isDropdownOpen && !loggedOut}
          anchorEl={dropdownAnchorEl}
          onClose={this.handleDropdownClose}
          onSwitchAccount={this.switchAccount}
          onAddStackClick={this.handleAddDialogOpen}
        />

        <AddStackDialog
          open={isAddDialogOpen && !loggedOut}
          onClose={this.handleAddDialogClose}
          onSwitchAccount={this.switchAccount}
        />
      </div>
    );
  }
}

SidebarHeader.propTypes = {
  onClose: PropTypes.func,
  onMouseLeave: PropTypes.func,
  isCollapsed: PropTypes.bool,
  isHovered: PropTypes.bool,
};

var mapStateToProps = function (state) {
  return {
    imagesLinks: state.images.links,
    currentAccount: state.accounts.currentAccount,
    currentUser: state.currentUser,
  };
};

export default connect(mapStateToProps, {
  setCurrentAccountByUUID,
  updateAccountTimestamp,
  updateUser,
})(withRouter(SidebarHeader));
